import Greenbay1 from '../../Media/Greenbay/Kamar 3 (1).webp'
import Greenbay2 from '../../Media/Greenbay/Kamar 3 (2).webp'
import Greenbay3 from '../../Media/Greenbay/Kamar 3 (3).webp'
import Greenbay4 from '../../Media/Greenbay/Kamar 3 (4).webp'
import Greenbay5 from '../../Media/Greenbay/Kamar 3 (5).webp'




const Kamar3images =[
    Greenbay1,Greenbay2,Greenbay3,Greenbay4,Greenbay5
]

export default Kamar3images;